import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TextByTextCard } from 'www-cms';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-text-by-text-card',
  imports: [DirectusDirective],
  templateUrl: './text-by-text-card.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextByTextCardComponent extends BaseBuildingBlockComponent {
  @Input({ required: true }) textByTextCardData!: TextByTextCard;

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }
}
